import { createAction } from "@ngrx/store";
import { IApplicationSetting } from "../../models/application/application-setting.model";

export const setApplicationSettings = createAction(
  '[ApplicationSetting] Set ApplicationSettings',
  (applicationSettings: IApplicationSetting[]) => ({applicationSettings})
);
